import { BellIcon, ExclamationCircleIcon } from "@heroicons/react/solid";

import DashboardContainer from "../../SharedComponents/DashboardContainer";
import CardNotification from "./CardNotification";

function Notifications() {
    return (
        <DashboardContainer title={"Notifications"} titleIcon={<BellIcon className="block h-5 w-5 mr-2"/>}>
            <div className="flex flex-col h-full">
                <div className="sm:-mx-6 lg:-mx-8">
                    <div className="align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <h3 className="text-md font-medium leading-6 text-indigo-900">
                            Recent
                        </h3>
                        <div className={"grid grid-flow-row lg:grid-cols-2 xl:grid-cols-3 gap-4 mt-2 text-sm mt-4"}>
                            <CardNotification
                                type={"red-card-notification"}
                                text={"You have 5 days to complete your Survey"}
                                icon={
                                    <ExclamationCircleIcon
                                        className={"h-5 w-5 text-red-100"}
                                        aria-hidden="true"
                                    />
                                }
                                linkText={"Complete survey now"}
                                date={"13/12/2021"}
                                shadow
                                dismissible
                            />
                            <CardNotification
                                type={"blue-card-notification"}
                                text={"You have 5 days to complete your Survey"}
                                icon={
                                    <ExclamationCircleIcon
                                        className={"h-5 w-5 text-blue-600"}
                                        aria-hidden="true"
                                    />
                                }
                                linkText={"Complete survey now"}
                                date={"13/12/2021"}
                                shadow
                            />
                            <CardNotification
                                type={"blue-card-notification"}
                                text={"You have 5 days to complete your Survey"}
                                icon={
                                    <ExclamationCircleIcon
                                        className={"h-5 w-5 text-blue-600"}
                                        aria-hidden="true"
                                    />
                                }
                                linkText={"Complete survey now"}
                                date={"13/12/2021"}
                                shadow
                            />
                            <CardNotification
                                type={"blue-card-notification"}
                                text={"You have 5 days to complete your Survey"}
                                icon={
                                    <ExclamationCircleIcon
                                        className={"h-5 w-5 text-blue-600"}
                                        aria-hidden="true"
                                    />
                                }
                                linkText={"Complete survey now"}
                                date={"13/12/2021"}
                                shadow
                            />
                        </div>
                        <h3 className="text-md font-medium leading-6 text-indigo-900 mt-8">
                            Past
                        </h3>
                        <div className={"grid grid-flow-row lg:grid-cols-2 xl:grid-cols-3 gap-4 mt-2 text-sm mt-4"}>
                            <CardNotification
                                type={"blue-card-notification"}
                                text={"You have 5 days to complete your Survey"}
                                icon={
                                    <ExclamationCircleIcon
                                        className={"h-5 w-5 text-blue-600"}
                                        aria-hidden="true"
                                    />
                                }
                                linkText={"Complete survey now"}
                                date={"13/12/2021"}
                                shadow
                            />
                            <CardNotification
                                type={"blue-card-notification"}
                                text={"You have 5 days to complete your Survey"}
                                icon={
                                    <ExclamationCircleIcon
                                        className={"h-5 w-5 text-blue-600"}
                                        aria-hidden="true"
                                    />
                                }
                                linkText={"Complete survey now"}
                                date={"13/12/2021"}
                                shadow
                            />
                            <CardNotification
                                type={"blue-card-notification"}
                                text={"You have 5 days to complete your Survey"}
                                icon={
                                    <ExclamationCircleIcon
                                        className={"h-5 w-5 text-blue-600"}
                                        aria-hidden="true"
                                    />
                                }
                                linkText={"Complete survey now"}
                                date={"13/12/2021"}
                                shadow
                            />
                            <CardNotification
                                type={"red-card-dismissed-notification"}
                                text={"You have 5 days to complete your Survey"}
                                icon={
                                    <ExclamationCircleIcon
                                        className={"h-5 w-5 text-red-600"}
                                        aria-hidden="true"
                                    />
                                }
                                linkText={"Complete survey now"}
                                date={"13/12/2021"}
                                shadow
                            />
                        </div>
                    </div>
                </div>
            </div>
        </DashboardContainer>
    )
}

export default Notifications;
